<template>
  <div ref="bg" :class="{'bg': showMenu}">
    <div class="nav" ref="nav" :class="[{'showNav': isScroll}, {'pb4': showMenu}]">
      <div class="left">
        <img src="./img/logo.png" alt="" class="logo" @click="jumpHome">
      </div>
      <div class="right">
        <span class="btn login" v-if="!showMenu" @click="goLogin">登录</span>
        <!-- <span class="btn register" v-if="!showMenu" @click="goSignup">注册</span> -->
        <img src="./img/menu.png" alt="" class="menu" v-if="!showMenu" @click="showMenu=true">
        <img src="./img/close.png" alt="" class="menu" v-else @click="showMenu=false">
      </div>
    </div>
    <div class="nav-menu" v-show="showMenu" ref="navMenu">
      <template v-for="(item, index) in menuNames">
        <van-collapse v-if="item.children" v-model="activeName" :border="false" accordion>
          <van-collapse-item :border="false"
            :title="item.name" :name="index"
            class="nav-menu-item" :class="{'active1': item.active}"
            @click="jump(item)" >
              <ul style="text-align: left; list-style: disc;">
                <li v-for="(subItem, subIndex) in item.children" :key="`c_${subIndex}`"
                  class="menu-item-children"
                  :class="{'active': subItem.active}"
                  @click="jump(subItem)">
                  {{subItem.name}}
                </li>
              </ul>
          </van-collapse-item>
        </van-collapse>
        <a v-else :class="{'active': item.active}"  @click="jump(item)">{{item.name}}</a>
      </template>
    </div>
  </div>
</template>
<script>
import { jumpPath, isCurrPath } from '@/utils/helper'
import vkTrack from '@/utils/_vktrack'
import tools from '@/utils/tools'

import { Lazyload, NavBar, Icon, Collapse, CollapseItem, Overlay, Swipe, SwipeItem, } from 'vant';
import Vue from 'vue';
Vue.use(Collapse);
Vue.use(CollapseItem);

export default {
  name: 'cHeader',
  data() {
    return {
      activeName: 0,
      isScroll: false,
      showMenu: false,
      menuNames: [
        { name: '首页', path: '/home', active: false },
        { name: 'VIPKID 大咖英语', path: '/bigstar', active: false },
        { name: '北美师资', path: '/teacher', active: false },
        { name: 'VIPKID 1对1(海外版)', path: '/oversea', active: false },
        { name: '剑桥考试体系', path: '', active: false, children: [
          { name: '剑少阶段 YLE', path: '/cambLevel', active: false },
          { name: '青少阶段 MSE', path: '/cambKPFLevel', active: false },
        ] },
        { name: 'VIPKID AI双师智学', path: '/ai', active: false },
        { name: 'VIPKID 双语文化素养', path: '/culture', active: false },
        { name: 'Dino阅读馆加盟', path: '/dinoRead', active: false },
        { name: '如何上课', path: '/steps', active: false },
      ],
    }
  },
  watch: {
    // 导航栏菜单出现时禁止滚动
    showMenu(val) {
      if (val) {
        document.body.style.overflow = 'hidden';
        this.$nextTick(() => {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
          this.$refs.bg.style.height = `${scrollTop + document.body.clientHeight}px`;
        });
      } else {
        // 关闭菜单时，检查是否有其他弹窗（如 loginIframe）存在
        // 如果有弹窗，不应该恢复滚动
        const hasPopup = document.querySelector('.login-iframe') !== null;
        if (!hasPopup) {
          document.body.style.overflow = 'visible';
        }
        this.$refs.bg.style.height = '100%';
      }
    },
  },
  methods: {
    isActive(menu, index) {
      if(menu.children && menu.children.length > 0) {
        return menu.children.some(item => isCurrPath(item.path))
      }
      return isCurrPath(menu.path)
    },
    jump(menu) {
      if(!menu.path) return
      const path = tools.getMatch(location.pathname)
      vkTrack.click(`parent_h5_web_${path}_click`)
      setTimeout(() => {
        jumpPath(menu.path)
      }, 300)
    },
    jumpHome() {
      jumpPath('/home')
    },
    handleScroll() {
      const headerHeight = this.$refs.nav.offsetHeight;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > headerHeight) {
        this.isScroll = true;
      } else {
        this.isScroll = false;
      }
      // fixed 定位的菜单不需要动态调整 paddingTop
      // this.$refs.navMenu && (this.$refs.navMenu.style.paddingTop = scrollTop + 20 + 'px')
    },
    goLogin(){
      let url = ''
      if (/MicroMessenger/i.test(navigator.userAgent)) {
        let qa = /^(http:|https:|\s)\/\/([a-zA-Z0-9-]{0,100}).vipkid-qa.com.cn\//i
        if (qa.test(window.location.href)) {
          url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd6458b851c9d175d&redirect_uri=http://stage-weixin.vipkid-qa.com.cn/oauth/validateBind&response_type=code&scope=snsapi_base&state=${encodeURIComponent('/entry/h5logincenter?isFromWechat=true&appId=10014')}#wechat_redirect`
        } else {
          url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbd56495f131c90a8&redirect_uri=http://weixin.vipkid.com.cn/oauth/validateBind&response_type=code&scope=snsapi_base&state=${encodeURIComponent('/entry/h5logincenter?isFromWechat=true&appId=10014')}#wechat_redirect`
        }
      } else {
        url = '/login?isFromWechat=true'
      }
      window.location.href = url
    },
    goSignup() {
      let url = ''
      if (/MicroMessenger/i.test(navigator.userAgent)) {
        let qa = /^(http:|https:|\s)\/\/([a-zA-Z0-9-]{0,100}).vipkid-qa.com.cn\//i
        if (qa.test(window.location.href)) {
          url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd6458b851c9d175d&redirect_uri=http://stage-weixin.vipkid-qa.com.cn/oauth/validateBind&response_type=code&scope=snsapi_base&state=${encodeURIComponent('/entry/h5logincenter?isFromWechat=true&target=signup&appId=10014')}#wechat_redirect`
        } else {
          url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbd56495f131c90a8&redirect_uri=http://weixin.vipkid.com.cn/oauth/validateBind&response_type=code&scope=snsapi_base&state=${encodeURIComponent('/entry/h5logincenter?isFromWechat=true&target=signup&appId=10014')}#wechat_redirect`
        }
      } else {
        url = '/login?isFromWechat=true&target=signup'
      }
      window.location.href = url
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    this.menuNames.forEach((item, index) => {
      if(item.children) {
        item.children.forEach(subItem => {
          const value = isCurrPath(subItem.path)
          subItem.active = value
          if(value) {
            item.active = value
            this.activeName = index
          }
        })
      } else {
        item.active = isCurrPath(item.path)
      }
    })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>
<style scoped lang="less">
@keyframes showNav{
  0%{
    opacity: 0
  }
  100%{
    opacity: 1
  }
}
@keyframes showMenu {
  0% {
    height: 0;
  }
  100% {
    height: 432px;
  }
}
.nav{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 15px 16px 8px 20px;
  margin: 0 auto;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  .right {
    display: flex;
    position: relative;
    z-index: 1001;
  }
}
.pb4{
  padding-bottom: 4px;
}
.showNav{
  z-index: 1000;
  animation: showNav 0.25s ease-in 1 forwards;
}
.logo{
  width: 80px;
  height: 37px;
}
.menu{
  width: 28px;
  height: 28px;
  margin-top: 5px;
  position: relative;
  z-index: 1001;
}
.nav-menu{
  background-color: #fff;
  padding: 15px 0 0 20px;
  border-radius: 0 0 16px 16px;
  animation: showMenu 0.25s ease-out 1 forwards;
  overflow: auto;
  position: fixed;
  top: 60px;
  left: 0;
  right: 0;
  max-height: calc(100vh - 60px);
  z-index: 999;
  box-shadow: 0 5px 20px rgba(248, 84, 21, 0.15);
  .nav-menu-item {
    padding: 12px 0;
    :deep(.van-cell) {
      font-size: 16px;
      color: rgba(47, 51, 56, 1);
      line-height: 24px;
      padding: 0;
    }
    &.active1 {
      :deep(.van-cell__title) {
        color: #f85415;
      }
    }
    :deep(.van-cell__title) {
      flex: none;
    }
    :deep(.van-cell__right-icon) {
      color: #000;
    }
    :deep(.van-collapse-item__content) {
      padding: 12px 0 0 0;
    }
    .menu-item-children {
      display: flex;
      align-items: center;

      color: #686868;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      padding: 0 0 12px 0;

      &:last-child {
        padding-bottom: 0;
      }
      &::before {
        content: '';
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background-color: #686868;
        display: inline-block;
        margin: 0 8px;
      }
    }
  }
}
.nav-menu a {
  color: #2F3338;
  font-size: 16px;
  line-height: 24px;
  padding: 12px 0;
  display: block;
}
.bg{
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 998;
}
.btn{
  width: 52px;
  height: 28px;
  line-height: 28px;
  border-radius: 8px;
  text-align: center;
  margin-top: 6px;
  display: inline-block;
  position: relative;
  z-index: 1001;
}
.login{
  border: 1px solid rgba(227, 229, 232, 1);
  color: rgba(47, 51, 56, 1);
  margin-right: 16px;
}
.register{
  background-color: rgba(248, 84, 21, 1);
  color: rgba(255, 255, 255, 1);
  margin-right: 16px;
  margin-left: 8px;
}
.active{
  color: #f85415 !important;
}
</style>
